<template>
    <div class="main-box">
        <div class="lg-card">
            <div class="lg-card-item" v-for="(v, i) in lgData" :key="i">
                <div class="lg-card-item-icon" :style="'backgroundColor:' + v.color">
                    <img :src="v.icon" alt="" />
                </div>
                <div class="lg-card-item-info">
                    <div class="lg-card-item-num" :style="'color:' + v.color">
                        {{ `${v.num}个` }}
                    </div>
                    <div class="lg-card-item-txt">{{ v.txt }}</div>
                </div>
            </div>
        </div>

        <el-row :gutter="20">
            <el-col :span="18">
                <div class="echarts-card">
                    <div class="echarts-card-header">
                        <div class="echarts-card-title">
                            岗位缺口数量统计分析
                        </div>
                        <div class="echarts-card-tool">
                            <el-button type="primary" @click="getPositionDetail()" btn-id='21' v-btn-set>查看数据明细</el-button>
                        </div>
                    </div>
                    <div class="echarts-card-tool card-search-header">
                        <el-cascader
                            clearable
                            :options="options"
                            v-model="lineForm.selected"
                            :props="{ checkStrictly: true }"
                            placeholder="请选择省份/城市"
                            @change="getDaily()">
                        </el-cascader>
                        <el-select v-model="lineForm.companyId" filterable clearable placeholder="请选择企业"
                            @change="getDaily()">
                            <el-option v-for="item in companyList" :label="item.name" :value="item.id"
                                :key="item.id"></el-option>
                        </el-select>
                        <el-select v-model="lineForm.requireId" filterable clearable placeholder="请选择需求"
                            @change="getDaily()">
                            <el-option v-for="item in requireList" :label="item.name" :value="item.id"
                                :key="item.id"></el-option>
                        </el-select>
                        <el-date-picker clearable @change="getDaily()" v-model="lineForm.time"
                            type="daterange" range-separator="~" start-placeholder="开始日期" end-placeholder="结束日期"
                            :picker-options="picker"
                            value-format="yyyy-MM-dd">
                        </el-date-picker>
                    </div>
                    <div class="echarts-card-container">
                        <v-chart v-show="!demoLine.graphic" ref="demoLine" :option="demoLine"></v-chart>
                        <noData v-show="demoLine.graphic"/>
                    </div>
                </div>
            </el-col>
            <el-col :span="6">
                <div class="echarts-card">
                    <div class="echarts-card-header">
                        <div class="echarts-card-title">企业岗位缺口数量排名</div>
                    </div>
                    <ul class="echarts-card-container hasTool" v-infinite-scroll="loadPositionRank" v-if="rankingData.list&&rankingData.list.length>0">
                        <li v-for="(item,index) in rankingData.list " :key="index">
                            <p>
                                <span :class='`item item${index}`'>{{index+1}}</span>{{item.companyName}}
                            </p>
                            <p>
                                <span>{{item.jobGapNumTotal}}个</span>
                            </p>
                        </li>
                    </ul>
                    <noData v-else/>
                </div>
            </el-col>
        </el-row>

        <el-row :gutter="20">
            <el-col :span="18">
                <div class="echarts-card">
                    <div class="echarts-card-header">
                        <div class="echarts-card-title">
                            TOP10缺口岗位分布（全部岗位）
                        </div>
                        <div class="echarts-card-tool">
                            <el-button type="primary" @click="getPositionTopDetail()" btn-id='21' v-btn-set>查看数据明细</el-button>
                        </div>
                    </div>
                    <div class="echarts-card-tool card-search-header">
                        <el-cascader
                            clearable
                            :options="options"
                            v-model="effectScatterForm.selected"
                            :props="{ checkStrictly: true }"
                            placeholder="请选择省份/城市"
                            @change="getPositionTop()">
                        </el-cascader>
                        <el-date-picker clearable @change="getPositionTop()" v-model="effectScatterForm.time"
                            type="date" placeholder="选择日期"
                            :picker-options="picker"
                            value-format="yyyy-MM-dd">
                        </el-date-picker>
                    </div>
                    <div class="echarts-card-container">       
                        <v-chart v-show="!demoEffectScatter.graphic" ref="demoEffectScatter" :option="demoEffectScatter"></v-chart>
                        <noData v-show="demoEffectScatter.graphic"/>
                    </div>
                </div>
            </el-col>
            <el-col :span="6">
                <div class="echarts-card text-cart">
                    <div class="text-cart-box">
                        <div class="text-title">更新频率：</div>
                        <div class="text-info">
                            平台所有数据更新频率均为T+1，今日数据均在明日凌晨3点统一更新。
                        </div>
                        <div class="text-title">数据显示规则：</div>
                        <div class="text-info">
                            总计和默认显示平台全部数据，如筛选某公司/某需求/某时间段，数据为该公司/该需求./该时间段的相关数据。
                        </div>
                        <div class="text-title">岗位缺口数量：</div>
                        <div class="text-info">
                            平台中招聘需求岗位所需的入职人员数量<br />
                            总计：累计平台中产生的所有招聘需求的数量<br />
                            进行中：平台中未完成招聘的需求数量<br />
                        </div>
                        <div class="text-title">用工企业数量：</div>
                        <div class="text-info">
                            使用新领招聘平台招需求人员的合作企业数量
                        </div>
                        <div class="text-title">缺口岗位：</div>
                        <div class="text-info">
                            使用平台发布的招聘需求中缺口岗位的类型
                        </div>
                    </div>
                </div>
            </el-col>
        </el-row>

        <el-dialog title="岗位缺口数据明细"
            :visible.sync="vacanciesDialog"
            width="12rem"
            center>
            <el-table :data="vacanciesTable" height="440" header-row-class-name="tableHeader"
                :row-class-name="tableRowClassName">
                <el-table-column prop="companyName" label="公司名称" align="center"></el-table-column>
                <!-- <el-table-column prop="requireName" label="需求名称" align="center"></el-table-column> -->
                <el-table-column prop="date" label="日期" show-overflow-tooltip align="center"></el-table-column>
                <el-table-column prop="processingNeedNum" label="进行中招聘需求数量" align="center"></el-table-column>
                <el-table-column prop="remainingJobGapNum" label="剩余岗位缺口数量" show-overflow-tooltip align="center"></el-table-column>
                <el-table-column prop="paidJobGapNum" label="已交付岗位缺口数量" align="center"></el-table-column>
                <el-table-column prop="jobGapNum" label="岗位缺口数量" align="center"></el-table-column>
                <el-table-column prop="employerNum" label="用工企业数量" align="center"></el-table-column>
            </el-table>
            <pagination :page="vacanciesData.pageNum" :limit="vacanciesData.pageSize" :total="vacanciesTotal" @pagination="otherPage"></pagination>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="exportPositionDetail()" btn-id='22' v-btn-set :disabled="vacanciesTable.length<=0">导出Excel</el-button>
                <el-button @click="vacanciesDialog = false">取 消</el-button>
            </span>
        </el-dialog>

        <el-dialog title="多维度缺口岗位统计"
            :visible.sync="jobsgDialog"
            width="12rem"
            center>
            <el-table :data="jobsTable" height="440" header-row-class-name="tableHeader"
                :row-class-name="tableRowClassName">
                <el-table-column prop="industryName" label="行业类别" show-overflow-tooltip align="center"></el-table-column>
                <el-table-column prop="jobName" label="职位" align="center"></el-table-column>
                <el-table-column prop="provinceName" label="省份" align="center"></el-table-column>
                <el-table-column prop="cityName" label="城市" align="center"></el-table-column>
                <el-table-column prop="jobGapNum" label="累计缺口数量" align="center"></el-table-column>
                <el-table-column prop="remainingJobGapNum" label="剩余缺口数量" align="center"></el-table-column>
            </el-table>
            <pagination :page="jobsData.pageNum" :limit="jobsData.pageSize" :total="jobsTotal" @pagination="otherPage1"></pagination>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="exportPositionTopDetail()" btn-id='22' v-btn-set :disabled="jobsTable.length<=0">导出Excel</el-button>
                <el-button @click="jobsgDialog = false">取 消</el-button>
            </span>
        </el-dialog>

    </div>
</template>

<script>
    import moment from "moment";
    import { provinceAndCityData } from "element-china-area-data";
    import pagination from '@/components/pagination'
    import { getPositionSum, getDaily, getPositionRank, getPositionTop, getPositionDetail, getPositionTopDetail, exportPositionDetail, exportPositionTopDetail} from "@/api/companyAnalysis/hiring";
    import { getCompanyList, getRequireList } from "@/api/common";
    import icon1 from "@/assets/image/icon-hiring-1.png";
    import icon2 from "@/assets/image/icon-hiring-2.png";
    import icon3 from "@/assets/image/icon-hiring-3.png";
    import icon4 from "@/assets/image/icon-hiring-4.png";
    import icon5 from "@/assets/image/icon-hiring-5.png";
    import resize from "@/utils/resize";
    export default {
        mixins: [resize],
        components:{
            pagination
        },
        data() {
            return {
                chartRefList: ["demoLine", "demoEffectScatter"],
                picker: {
                    disabledDate(time) {
                        return time.getTime() > Date.now(); //限制不能选择当前时间之后的日期
                    },
                },
                lgData: [{
                        color: "#FF9502",
                        icon: icon1,
                        num: "0",
                        txt: "剩余岗位缺口数量",
                    },
                    {
                        color: "#5756D7",
                        icon: icon2,
                        num: "0",
                        txt: "进行中招聘需求数量",
                    },
                    {
                        color: "#FF3A30",
                        icon: icon3,
                        num: "0",
                        txt: "总计岗位缺口数量",
                    },
                    {
                        color: "#34C758",
                        icon: icon4,
                        num: "0",
                        txt: "总计已交付岗位缺口数量",
                    },
                    {
                        color: "#007AFF",
                        icon: icon5,
                        num: "0",
                        txt: "总计用工企业数量",
                    }
                ],
                lineForm: {
                    companyId: "",
                    requireId: "",
                    time: [],
                    selected:[]
                },
                effectScatterForm: {
                    time: '',
                    selected:[]
                },
                options: provinceAndCityData,//省市数据

                demoLine: {},
                demoEffectScatter: {},
                
                consumeSum: {},
                companyList: [],
                requireList: [],

                rankingData:{
                    list:[],
                    pageSize:10,
                    pageNum:1
                },
                

                vacanciesDialog:false,
                vacanciesData:{
                    pageSize:10,
                    pageNum:1
                },
                vacanciesTable:[],
                vacanciesTotal:0,

                jobsgDialog:false,
                jobsData:{
                    pageSize:10,
                    pageNum:1
                },
                jobsTable:[],
                jobsTotal:0,
            };
        },
        mounted() {
            this.getPositionSum();
            this.getCompanyList();
            this.getRequireList();
            this.getPositionRank()
            this.getDaily();
            this.getPositionTop();
        },
        methods: {
            // 设置斑马色
            tableRowClassName({ row, rowIndex }){
                if ((rowIndex + 1) % 2 === 0) {
                    return "greenRow";
                } else {
                    return "";
                }
            },
            // 获取头部指标数据
            getPositionSum() {
                getPositionSum().then((res) => {
                    if (res.code == 1) {
                        this.consumeSum = res.data;
                        this.lgData[0].num = this.consumeSum.remainingJobGapNum;
                        this.lgData[1].num = this.consumeSum.processingNeedNum;
                        this.lgData[2].num = this.consumeSum.jobGapNum;
                        this.lgData[3].num = this.consumeSum.paidJobGapNum;
                        this.lgData[4].num = this.consumeSum.employerNum;
                    }
                });
            },
            // 获取公司下拉框
            getCompanyList() {
                getCompanyList().then((res) => {
                    if (res.code == 1) {
                        this.companyList = res.data;
                    }
                })
            },
            // 获取需求下拉数据
            getRequireList() {
                let params = {
                    companyId: this.lineForm.companyId ?  this.lineForm.companyId : undefined
                }
                getRequireList(params).then((res) => {
                    if (res.code == 1) {
                        this.requireList = res.data;
                    }
                })
            },
            // 岗位缺口数量统计分析数据
            getDaily() {
                let option = {
                    color: ["#597ED8", "#33C758"],
                    tooltip: {
                        trigger: "axis",
                    },
                    legend: {
                        data: ["剩余岗位缺口数量", "交付岗位缺口数量"],
                    },
                    grid: {
                        left: "3%",
                        right: "4%",
                        bottom: "3%",
                        containLabel: true,
                    },
                    xAxis: {
                        type: "category",
                        boundaryGap: false,
                        data: [],
                    },
                    yAxis: {
                        type: "value",
                    },
                    series: []
                }
                option.legend.data.forEach((v,i) => {
                    i==0?option.series.push({
                        name: v,
                        type: "bar",
                        data: [],
                        barWidth : 10,//柱图宽度
                        //柱形图圆角，鼠标移上去效果
                        // emphasis: {
                        //     itemStyle:{
                        //         color:'#F2F2F2'
                        //     } 
                        // },
                        itemStyle: {
                            //柱形图圆角，初始化效果
                            normal: {
                                barBorderRadius:[20, 20, 20, 20]
                            }
                        }
                    }):option.series.push({
                        name: v,
                        type: "line",
                        data: []
                    })
                })
                const data = {
                    companyId:this.lineForm.companyId ? this.lineForm.companyId : undefined,
                    requireId: this.lineForm.requireId ? this.lineForm.requireId : undefined,
                    beginDate: this.lineForm.time &&(this.lineForm.time.length ? moment(this.lineForm.time[0]).format() : undefined),
                    endDate: this.lineForm.time &&(this.lineForm.time.length ? moment(this.lineForm.time[1]).format() : undefined),
                    provinceCode:this.lineForm.selected[0]?this.lineForm.selected[0] : undefined,
                    cityCode:this.lineForm.selected[1]?this.lineForm.selected[1] : undefined
                } 
                getDaily(data).then((res) => {
                    if (res.code == 1) {
                        let data = res.data;
                        data.forEach((v) => {
                            option.xAxis.data.push(v.date);
                            option.series[0].data.push(v.remainingJobGapNum);
                            option.series[1].data.push(v.paidJobGapNum);
                        });
                        this.$nextTick(()=>{
                            this.$refs.demoLine.clear()
                            this.demoLine = option;
                        })
                    }else{
                        this.$nextTick(()=>{
                            this.$refs.demoLine.clear()
                            this.demoLine= this.emptyData()
                        })
                    }
                })
            },
            // 企业岗位缺口数量的排行榜（以发布的缺口数量排行）
            getPositionRank(){
                const data={
                    pageSize:this.rankingData.pageSize,
                    pageNum:this.rankingData.pageNum
                }
                getPositionRank(data).then(res=>{
                    if(res.code==1&&res.data.list){
                        this.rankingData.list = [...this.rankingData.list,...res.data.list]
                    }  
                })
            },
            // 获取TOP10缺口岗位分布
            getPositionTop() {
                const colors = ['#E3E952','#65D999','#62D2CD','#78ADF1','#7E95F5','#FF6C6B','#F067FA','#E8C284','#FF5D7C','#4AC7F8'] // 光晕色值
                const coordinates=[[266,1685],[709,1575],[389,0],[0,0],[130,700],[476,1880], [586, 78.1],[857, 0], [995, 0], [0, 2000]] //坐标位置
                const size = [65,60,55,50,45,40,35,30,25,20] // 光晕大小
                let list = []
                let option = {
                    xAxis: {
                        show:false,
                    },
                    yAxis: {
                        show:false,
                    },
                    series: []
                }
                const data = {
                    date: this.effectScatterForm.time ? moment(this.effectScatterForm.time).format() : undefined,
                    provinceCode:this.effectScatterForm.selected[0]?this.effectScatterForm.selected[0] : undefined,
                    cityCode:this.effectScatterForm.selected[1]?this.effectScatterForm.selected[1] : undefined
                }
                getPositionTop(data).then((res) => {
                    if (res.code == 1&&res.data&&res.data.length>0) {
                        res.data = res.data.sort((a,b)=>{ return b.jobGapNum-a.jobGapNum})//降序
                        res.data.forEach((v,i) => {
                            v.jobGapNum = Number(v.jobGapNum)
                            list.push([...coordinates[i],Number(v.jobGapNum),v.jobName])
                            option.series.push(
                                {
                                    type: 'effectScatter',
                                    data: []
                                } 
                            )
                        })
                       
                        option.series.forEach((v,i)=>{
                            option.series[i].data.unshift(list[i])
                            option.series[i].symbolSize = (e)=> {
                                return size[i];
                            }
                            option.series[i].label = {
                                position: "inside",
                                show: true,
                                lineHeight: 15,
                                color:'#333333',
                                fontSize:12,
                                formatter:(e)=>{
                                    return `${e.data[e.data.length-1]}\n${e.data[2]} `
                                }
                            }
                            option.series[i].itemStyle= {
                                normal: {
                                    color: (e)=>{
                                        return colors[i]
                                    }
                                }
                            }
                        })
                        this.$nextTick(()=>{
                            this.$refs.demoEffectScatter.clear()
                            this.demoEffectScatter = option
                        })
                    }else{
                        this.$nextTick(()=>{
                            this.$refs.demoEffectScatter.clear()
                            this.demoEffectScatter= this.emptyData()
                        })
                    }
                })
            },
            // 岗位缺口数量统计明细
            getPositionDetail(){
                this.vacanciesDialog = true
                let data = {
                    companyId:this.lineForm.companyId ? this.lineForm.companyId : undefined,
                    requireId: this.lineForm.requireId ? this.lineForm.requireId : undefined,
                    beginDate: this.lineForm.time &&(this.lineForm.time.length ? moment(this.lineForm.time[0]).format() : undefined),
                    endDate: this.lineForm.time &&(this.lineForm.time.length ? moment(this.lineForm.time[1]).format() : undefined),
                    provinceCode:this.lineForm.selected[0]?this.lineForm.selected[0] : undefined,
                    cityCode:this.lineForm.selected[1]?this.lineForm.selected[1] : undefined,
                    pageSize:this.vacanciesData.pageSize,
                    pageNum:this.vacanciesData.pageNum
                }
                getPositionDetail(data).then(res=>{
                    if(res.code == 1 && res.data.list){
                        this.vacanciesTable = res.data.list
                        this.vacanciesTotal = res.data.total
                    }else{
                        this.vacanciesTable = []
                        this.vacanciesTotal = 0
                    }
                })
            },
            // 缺口岗位分布数据明细
            getPositionTopDetail(){
                this.jobsgDialog = true
                let data = {
                    date: this.effectScatterForm.time ? moment(this.effectScatterForm.time).format() : undefined,
                    provinceCode:this.effectScatterForm.selected[0]?this.effectScatterForm.selected[0] : undefined,
                    cityCode:this.effectScatterForm.selected[1]?this.effectScatterForm.selected[1] : undefined,
                    pageSize:this.jobsData.pageSize,
                    pageNum:this.jobsData.pageNum
                }
                getPositionTopDetail(data).then(res=>{
                    if(res.code == 1 && res.data.list){
                        this.jobsTable = res.data.list
                        this.jobsTotal = res.data.total
                    }else{
                        this.jobsTable = []
                        this.jobsTotal = 0
                    }
                })
            },
            // 动态加载数据
            loadPositionRank(){
                this.rankingData.pageNum+=1
                this.getPositionRank()
            },
            // 无数据
            emptyData(){
				let option = {
					graphic: {
						type: 'text',
						style: {
							text: 'There\'s no data...',
							fill: '#595959',
							fontSize: "14"
						}
					}
				}
				return option;
			},
            // 切换分页
            otherPage(e) {
                this.vacanciesData.pageNum = e.pageNum
                this.vacanciesData.pageSize = e.pageSize
                this.getPositionDetail()
            }, 
            // 导出岗位缺口数据明细
            exportPositionDetail(){
                let data = {
                    companyId:this.lineForm.companyId ? this.lineForm.companyId : undefined,
                    requireId: this.lineForm.requireId ? this.lineForm.requireId : undefined,
                    beginDate: this.lineForm.time &&(this.lineForm.time.length ? moment(this.lineForm.time[0]).format() : undefined),
                    endDate: this.lineForm.time &&(this.lineForm.time.length ? moment(this.lineForm.time[1]).format() : undefined),
                    provinceCode:this.lineForm.selected[0]?this.lineForm.selected[0] : undefined,
                    cityCode:this.lineForm.selected[1]?this.lineForm.selected[1] : undefined,
                    pageSize:this.vacanciesData.pageSize,
                    pageNum:this.vacanciesData.pageNum
                }
                exportPositionDetail(data).then(res=>{
                    if(res.code == 1){
                        let url = res.data.url
                        window.open(url)
                    }
                })
            },
            otherPage1(e){
                this.jobsData.pageNum = e.pageNum
                this.jobsData.pageSize = e.pageSize
                this.getPositionTopDetail()
            },

            // 缺口岗位分布数据明细
            exportPositionTopDetail(){
                let data = {
                    date: this.effectScatterForm.time ? moment(this.effectScatterForm.time).format() : undefined,
                    provinceCode:this.effectScatterForm.selected[0]?this.effectScatterForm.selected[0] : undefined,
                    cityCode:this.effectScatterForm.selected[1]?this.effectScatterForm.selected[1] : undefined,
                    pageSize:this.jobsData.pageSize,
                    pageNum:this.jobsData.pageNum
                }
                exportPositionTopDetail(data).then(res=>{
                    if(res.code == 1){
                        let url = res.data.url
                        window.open(url)
                    }
                })
            }
        },
    };
</script>

<style lang="scss" scoped>

    .echarts-card {
        .echarts-card-container {
            .chart-table {
                width: 100%;
                height: 100%;

                .el-row {
                    height: 100%;

                    .el-col {
                        height: 100%;
                    }
                }

                .chart-table-row {
                    display: flex;
                    flex-direction: column;
                    height: 100%;

                    .chart-table-title {
                        text-align: center;
                        font-size: 0.14rem;
                        color: #333;
                        height: 0.24rem;
                        line-height: 0.24rem;
                    }

                    .chart-table-title-2 {
                        text-align: left;
                    }

                    .chart-table-info {
                        flex: 1;
                        height: 100%;
                        display: flex;
                        flex-direction: column;
                        justify-content: space-around;
                        align-items: center;
                        text-align: center;
                        font-size: .14rem;
                        font-weight: 400;
                        color: #333;
                    }
                    .chart-table-index{
                        .item{
                            font-size: .12rem;
                            color: #fff;
                            min-width: .2rem;
                            min-height: .2rem;
                            border-radius: 50%;
                            background: #DFDFDF;
                            display: flex;
                            justify-content: center;
                            align-items: center;
                        }
                        :nth-of-type(1).item{
                            background: #FF3A30;
                        }
                        :nth-of-type(2).item{
                            background: #FF9502;
                        }
                        :nth-of-type(3).item{
                            background: #33C758;
                        }
                    }
                }
            }
        }
    }

    .hasTool {
        overflow: auto;
        list-style: none;
        padding-left: 0;
        padding-right: .1rem;
        li{
            display: flex;
            justify-content: space-between;
            p:first-child{
                width: 80%;
                white-space: nowrap;
                text-overflow: ellipsis;
                overflow: hidden;
                .item{
                    width: 0.2rem;
                    height: 0.2rem;
                    color: #fff;
                    font-size: 0.12rem;
                    display: inline-block;
                    text-align: center;
                    line-height: 0.2rem;
                    border-radius: 50%;
                    margin-right: 0.1rem;
                    background-color: #dfdfdf;
                }
                .item0{
                    background-color: #FF3A30;
                }
                .item1{
                    background-color: #FF9502;
                }
                .item2{
                    background-color: #33C758;                    
                }
            }
        }
    }

    .card-search-header{
        padding-top: .1rem;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        .el-cascader,.el-select{
            margin-right: .1rem;
        }
        .el-cascader{
            margin-top: -1px;
        }
    }

    .text-cart {
        overflow: auto;
        padding: 0.26rem 0.16rem 0.16rem 0.16rem;
        line-height: 1.5em;

        .text-title {
            font-size: 0.16rem;
            color: #333;
            font-weight: 500;
        }

        .text-info {
            font-size: 0.12rem;
            color: #999;
        }
    }
// ["#FF9502", "#5756D7", "#FF2C55", "#00BB7B"]
    .color-title-1{
        color: #FF9502 !important;
    }
    .color-title-2{
        color: #5756D7 !important;
    }
    .color-title-3{
        color: #FF2C55 !important;
    }
    .color-title-4{
        color: #00BB7B !important;
    }
</style>